import React, { ChangeEvent, useEffect, useState } from "react";
import {
  Grid,
  Tab,
  Tabs,
} from "@material-ui/core";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import TabPanel from "components/tabPanel";
import { Wrapper } from "components/wrapper";
import { TabsContainer } from "./publications.styles";
import { DiaryTabContent } from "./tabsContents/diaryTabContent.component";
import { PublicationTabContent } from "./tabsContents/publicationTabContent.component";
import { usePublicationsController } from "./context/publications-controller";
import { usePublicationsDispatch, usePublicationsState } from "./context/publications-context";
import { ICategoriesPublicationListResponnse } from "models/response/categories-publication-list-responnse";
import CustomBackdrop from "components/backdrop";

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

export const PublicationsPage = () => {
  const publicationsDispatch = usePublicationsDispatch();
  const { loading, categories } = usePublicationsState();
  const { onInit } = usePublicationsController();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await onInit();

    })();

  }, []);

  const [activeTab, setActiveTab] = useState<number>(0);

  const handleChangeTab = (_event: ChangeEvent<{}>, value: number) => {


    setActiveTab(value);
  };

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Diário Oficial" },
        ]}
      />
      <PageTitle>Diário Oficial</PageTitle>
      <Wrapper>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TabsContainer>
              <Tabs
                value={activeTab}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                onChange={handleChangeTab}
              >
                <Tab
                  label="Diário Oficial Próprio"
                  key={0}
                  value={0}
                  {...a11yProps(0)}
                />
                {categories?.map((item: ICategoriesPublicationListResponnse, index: number) => (
                  <Tab
                    label={item.description}
                    key={index + 1}
                    value={index + 1}
                    {...a11yProps(index + 1)}
                  />
                ))}
              </Tabs>
            </TabsContainer>
          </Grid>
          <Grid item xs={12}>
            <CustomBackdrop open={loading} />
            <TabPanel key={"diario-oficial"} value={activeTab} index={0}>
              <DiaryTabContent />
            </TabPanel>
            {categories?.map((item: ICategoriesPublicationListResponnse, index: number) => (
              <TabPanel key={index + 1} value={activeTab} index={index + 1}>
                <PublicationTabContent categoryId={item.id} description={item.description}></PublicationTabContent>
              </TabPanel>))}
          </Grid>
        </Grid>
      </Wrapper>
    </>
  );
};
